import { buildPrimarySiteUrl } from './canonicalHost';

const SITE = {
  zh: {
    name: 'Oblitrok',
    defaultTitle: 'Oblitrok | 技能服务与需求协作平台',
    defaultDescription: 'Oblitrok 连接技能服务者、需求发布者和二手资源，支持服务预约、需求协作、消息沟通和平台托管付款。',
    accountTitle: '账户区域 | Oblitrok',
  },
  en: {
    name: 'Oblitrok',
    defaultTitle: 'Oblitrok | Skill services and requirement collaboration',
    defaultDescription: 'Oblitrok connects skill providers, requirement owners, and secondhand resources with bookings, requirement collaboration, messaging, and escrow workflows.',
    accountTitle: 'Account area | Oblitrok',
  },
};

const PUBLIC_ROUTES = [
  { match: /^\/$/, zh: ['Oblitrok | 技能服务与需求协作平台', '发现技能服务、发布需求、沟通协作并通过平台托管完成交易。'], en: ['Oblitrok | Skill services and requirement collaboration', 'Find skill services, post requirements, collaborate through messages, and complete work with platform escrow.'] },
  { match: /^\/services\/?$/, zh: ['技能服务市场 | Oblitrok', '浏览已发布技能服务，按分类、服务方式和关键词筛选合适服务者。'], en: ['Service marketplace | Oblitrok', 'Browse live skill services and filter providers by category, delivery method, and keyword.'] },
  { match: /^\/services\/[^/]+$/, zh: ['服务详情 | Oblitrok', '查看服务套餐、服务者信誉、相关需求，并发起预约或沟通。'], en: ['Service detail | Oblitrok', 'Review service packages, provider trust signals, related requirements, and booking options.'] },
  { match: /^\/tasks\/?$/, zh: ['需求大厅 | Oblitrok', '浏览真实需求，比较预算、状态和交付要求后提交方案。'], en: ['Requirement hall | Oblitrok', 'Explore real requirements, compare budget and delivery needs, then submit the right proposal.'] },
  { match: /^\/tasks\/[^/]+$/, zh: ['需求详情 | Oblitrok', '查看需求说明、投稿、评论和推荐服务，参与需求协作流程。'], en: ['Requirement detail | Oblitrok', 'Review requirement details, submissions, comments, and recommended services for collaboration.'] },
  { match: /^\/secondhand\/?$/, zh: ['二手市场 | Oblitrok', '浏览平台用户发布的二手商品，联系卖家并保留沟通记录。'], en: ['Secondhand marketplace | Oblitrok', 'Browse secondhand items from platform users and contact sellers with conversation history.'] },
  { match: /^\/secondhand\/[^/]+$/, zh: ['商品详情 | Oblitrok', '查看二手商品详情、卖家信息、收藏和举报入口。'], en: ['Product detail | Oblitrok', 'Review secondhand product details, seller information, favorites, and report options.'] },
  { match: /^\/forum\/?$/, zh: ['社区论坛 | Oblitrok', '浏览平台社区讨论、经验分享和需求协作话题。'], en: ['Community forum | Oblitrok', 'Browse community discussions, experience sharing, and requirement collaboration topics.'] },
  { match: /^\/forum\/categories\/[^/]+$/, zh: ['论坛板块 | Oblitrok', '查看指定论坛板块下的讨论主题和回复。'], en: ['Forum category | Oblitrok', 'View discussion topics and replies in a forum category.'] },
  { match: /^\/forum\/posts\/[^/]+$/, zh: ['论坛帖子 | Oblitrok', '阅读论坛帖子详情并参与社区回复。'], en: ['Forum post | Oblitrok', 'Read forum post details and join community replies.'] },
  { match: /^\/freelancers\/?$/, zh: ['自由职业者 | Oblitrok', '发现平台服务者资料、技能、评分和服务能力。'], en: ['Freelancers | Oblitrok', 'Discover provider profiles, skills, ratings, and service capabilities.'] },
  { match: /^\/freelancers\/[^/]+$/, zh: ['服务者资料 | Oblitrok', '查看服务者介绍、技能、评分和过往服务表现。'], en: ['Freelancer profile | Oblitrok', 'Review a provider profile, skills, ratings, and service history.'] },
  { match: /^\/reviews\/?$/, zh: ['评价 | Oblitrok', '查看平台评价与服务反馈，辅助交易决策。'], en: ['Reviews | Oblitrok', 'Review platform feedback and service ratings to support transaction decisions.'] },
  { match: /^\/about\/?$/, zh: ['关于 Oblitrok | Oblitrok', '了解 Oblitrok 技能服务与需求协作平台的定位和运营边界。'], en: ['About Oblitrok | Oblitrok', 'Learn about the Oblitrok service marketplace and requirement collaboration platform.'] },
  { match: /^\/help\/?$/, zh: ['帮助中心 | Oblitrok', '查看注册登录、发布需求、预约服务、钱包和平台安全说明。'], en: ['Help center | Oblitrok', 'Find guidance for accounts, requirements, service bookings, wallet flows, and platform safety.'] },
  { match: /^\/payments\/?$/, zh: ['Payment flow | Oblitrok', 'Review how Oblitrok buyers use hosted checkout and platform payment records for skill service orders.'], en: ['Payment flow | Oblitrok', 'Review how Oblitrok buyers use hosted checkout and platform payment records for skill service orders.'] },
  { match: /^\/terms\/?$/, zh: ['使用条款 | Oblitrok', '了解 Oblitrok 平台的账号、使用、付款和内容规则。'], en: ['Terms of Use | Oblitrok', 'Review the account, conduct, payment, and content rules for Oblitrok.'] },
  { match: /^\/privacy-policy\/?$/, zh: ['隐私政策 | Oblitrok', '了解 Oblitrok 如何收集、使用、保存和保护平台用户信息。'], en: ['Privacy Policy | Oblitrok', 'Learn how Oblitrok collects, uses, retains, and protects platform user information.'] },
  { match: /^\/cookie-policy\/?$/, zh: ['Cookie 政策 | Oblitrok', '了解 Oblitrok 如何使用 Cookie、本地存储和类似技术。'], en: ['Cookie Policy | Oblitrok', 'Learn how Oblitrok uses cookies, local storage, and similar technologies.'] },
];

const PRIVATE_ROUTES = /^\/(profile|dashboard|messages|wallet|checkout|settings|notifications|create-task|tasks\/create|tasks\/mine|requirements\/mine|services\/new|services\/mine|secondhand\/new|forum\/post\/create)(\/|$)/;

function normalizeLanguage(language) {
  return language === 'en' ? 'en' : 'zh';
}

function normalizePathname(pathname) {
  if (!pathname || pathname === '/') return '/';
  return pathname.endsWith('/') && pathname.length > 1 ? pathname.slice(0, -1) : pathname;
}

function buildCanonical(pathname) {
  return buildPrimarySiteUrl(pathname === '/' ? '/' : pathname);
}

export function getSeoMetadata({ pathname = '/', language = 'zh' } = {}) {
  const lang = normalizeLanguage(language);
  const path = normalizePathname(pathname);
  const site = SITE[lang];
  const matched = PUBLIC_ROUTES.find(route => route.match.test(path));

  if (matched) {
    const [title, description] = matched[lang];
    return {
      title,
      description,
      canonical: buildCanonical(path),
      ogType: 'website',
      robots: 'index,follow',
      siteName: site.name,
      locale: lang === 'zh' ? 'zh_CN' : 'en_US',
    };
  }

  if (PRIVATE_ROUTES.test(path)) {
    return {
      title: site.accountTitle,
      description: site.defaultDescription,
      canonical: buildCanonical(path),
      ogType: 'website',
      robots: 'noindex,nofollow',
      siteName: site.name,
      locale: lang === 'zh' ? 'zh_CN' : 'en_US',
    };
  }

  return {
    title: site.defaultTitle,
    description: site.defaultDescription,
    canonical: buildCanonical(path),
    ogType: 'website',
    robots: 'noindex,nofollow',
    siteName: site.name,
    locale: lang === 'zh' ? 'zh_CN' : 'en_US',
  };
}
